import { render } from "./SwitchBordered.vue?vue&type=template&id=a1c3dce2&scoped=true"
import script from "./SwitchBordered.vue?vue&type=script&lang=js"
export * from "./SwitchBordered.vue?vue&type=script&lang=js"

import "./SwitchBordered.vue?vue&type=style&index=0&id=a1c3dce2&scoped=true&lang=css"

import exportComponent from "/usr/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1c3dce2"]])

export default __exports__